import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { API } from "api";
import { UTILS } from "utils";
import DashboardBranchesTable from "features/store/containers/branchContainer";
import AppContainer from "components/ui/AppContainer";
import useUserType from "hooks/useUserType";
import useCatalogue from "hooks/useCatalogue";
import MerchantSavingBenchmarkModal from "../components/MerchantSavingBenchmarkModal";
import AppWidgetCard from "components/ui/AppWidgetCard";

const Dashboard = () => {

  const { currentLanguage } = useSelector((state) => state.LanguageSlice);
  const [stats, setStats] = useState({});
  const { t } = useTranslation();

  const getStats = async () => {
    const userDetail = UTILS.getCurrentUser();
    const result = await API.GET_STATS({
      token: userDetail.token,
      language: currentLanguage,
    });
    if (result && result.success === 1 && UTILS.isValidObject(["data"], result)) {
      const groupedOrders = result?.data?.orders?.reduce((result, item) => {
        const groupKey = item?.orderStatus;
        result[groupKey] = item;
        return result;
      }, {})
      setStats({ ...result?.data, orders: groupedOrders })
    }
  };


  const currentMonthSaving = useMemo(()=>{
    if(stats?.merchantSavings && !stats?.merchantSavings?.customBenchmarkProvided){
      return <p className="font-montserrat font-semibold text-16px text-center m-0 my-1.5">For Savings, <Link to="/app/dashboard/settings/business?tab=2">Add Vendor BenchMark</Link></p>
    }
    let value = stats?.currentMonthSaving ?? 0
    if(!stats?.currentMonthSaving){
      const percentSave = stats?.merchantSavings?.vendorBenchmark - stats?.merchantSavings?.restHeroBenchmark
      const savedThisMonth = Number((stats?.totalCurrentMonthEarned *(percentSave/100)).toString())
      value = isNaN(savedThisMonth) ? 0 : savedThisMonth
    }
    return <p className="font-montserrat font-semibold text-40px text-center m-0">{+value?.toFixed(2)}</p>
  },[stats.merchantSavings])

  useEffect(() => {
    getStats();
  }, []);

  const Analytics = [
    {
      heading: "Total Customers",
      count: stats?.customersCount,
      isPrice:false, 
    },
    {
      heading: "Completed Orders",
      count: stats?.orders?.["COMPLETE"]?.count,
      isPrice:false, 
    },
    {
      heading: "Rejected Orders",
      count: stats?.orders?.["REJECTED"]?.count,
      isPrice:false, 
    },
    {
      heading: "Canceled Orders",
      count: stats?.orders?.["CANCELLED"]?.count,
      isPrice:false, 
    },
    {
      heading: `Savings With RestHero`,
      content: currentMonthSaving,
      isPrice:true, 
    },
  ]

  return (
    <AppContainer title={t("Dashboard")}>
      <div className="grid md:grid-cols-3 lg:grid-cols-5 gap-1 md:gap-6 items-stretch">
          {Analytics?.map(({ heading, count, isPrice }, index) => (
            <div className="col-span-2 md:col-span-1 h-full " key={index}>
            <AppWidgetCard title={t(heading)} amount={count ?? 0} isPrice={isPrice} />
            </div>
          ))}
        </div>
        <DashboardBranchesTable />
        <MerchantSavingBenchmarkModal
          merchantSavings={stats?.merchantSavings}
          setStats={setStats}
        />
    </AppContainer>
  );
};
export default Dashboard;
